import React, { useState, useRef, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Dimensions, SafeAreaView, Platform, StatusBar, ActivityIndicator, Image, ScrollView, TextInput, inputRef, FlatList } from 'react-native';
import axios from 'axios';
import Svg, { Path, G, Rect, Mask, Ellipse, ClipPath } from 'react-native-svg';
import { Ionicons } from '@expo/vector-icons';
const { width, height } = Dimensions.get('window');

// Ícone de seta para voltar
const BackArrowIcon = () => (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <Path
            d="M18.5489 0.939645C19.151 1.52543 19.151 2.47518 18.5489 3.06097L9.36108 12.0003L18.5489 20.9396C19.151 21.5254 19.151 22.4752 18.5489 23.061C17.9469 23.6468 16.9707 23.6468 16.3686 23.061L5.00049 12.0003L16.3686 0.939645C16.9707 0.353859 17.9469 0.353859 18.5489 0.939645Z"
            fill="#004aad"
        />
    </Svg>
);

const RemediosFav = ({ route, navigation }) => {


    const { id = null, status = 1, classificacao = '', tipo = '', usuario_id, status_user, focusInput = false } = route.params || {};
    const inputRef = useRef(null); // Cria uma referência para o TextInput
    const [usuario, setUsuario] = useState({ status_user });
    const [isFocused, setIsFocused] = useState(focusInput);

    useEffect(() => {
        // Garante que o inputRef está disponível antes de usar
        if (focusInput && inputRef.current) {
            inputRef.current.focus(); // Foca no input e ativa o teclado
        }
    }, [focusInput]);

    const [searchText, setSearchText] = useState('');

    const handleSearch = (text) => {
        setSearchText(text);
        console.log('Search Text:', text);
    };
    const [loading, setLoading] = useState(false);

    const [medicamentos, setMedicamentos] = useState([]);

    useEffect(() => {
        async function buscarMedicamentos() {
            const url = `https://api-doseexata.josuejuca.com/api/v1/favoritos/${usuario_id}`;
            
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                });
                if (!response.ok) {
                    throw new Error('Erro na requisição: ' + response.statusText);
                }
                const data = await response.json();
                setMedicamentos(data);
            } catch (error) {
                console.error('Erro ao buscar medicamentos:', error);
            }
        }
        buscarMedicamentos();
    }, []);


    useEffect(() => {
        if (id) {
            fetchImovelData(id);
        }
    }, [id, status]);


    if (loading) {
        return (
            <SafeAreaView style={styles.safeArea}>
                <ActivityIndicator size="large" color="#004aad" />
            </SafeAreaView>
        );
    }


    return (
        <SafeAreaView style={styles.safeArea}>
            <View style={styles.headerContainer}>
                <TouchableOpacity onPress={() => navigation.navigate('Home', { usuario_id })} style={styles.backButton}>
                    <BackArrowIcon />
                </TouchableOpacity>
                <Text style={styles.headerTitle} allowFontScaling={false}>Remédios Favoritos</Text>
            </View>

            <Text style={styles.classificacaoText} allowFontScaling={false}>
                Meus favoritos
            </Text>
            <View
                style={[
                    styles.searchContainer,
                    isFocused && styles.searchContainerFocused, // Estilo aplicado no foco
                ]}
            >
                <Ionicons name="search" size={24} color={isFocused ? "#004aad" : "#808080"} style={styles.searchIcon} />
                <TextInput
                    ref={inputRef}
                    // 
                    style={styles.searchInput}
                    placeholder="Buscar medicamento"
                    placeholderTextColor="#a9a9a9"
                    value={searchText}
                    onChangeText={setSearchText}
                    autoCorrect={false}
                    autoCapitalize="none"
                    onFocus={() => setIsFocused(true)} // Foco no input
                    onBlur={() => setIsFocused(false)} // Perda de foco
                    underlineColorAndroid="transparent" // Remove a borda no Android
                />
            </View>
            <ScrollView style={styles.container}>
                <FlatList
                    data={medicamentos.filter(item => item.nome.toLowerCase().includes(searchText.toLowerCase()))}
                    keyExtractor={(item) => item.id.toString()}
                    renderItem={({ item }) => (
                        <TouchableOpacity
                            onPress={() => navigation.navigate('RemedioDetalhes', { usuario_id, id: item.id })}
                        >
                            <View style={styles.historyItem}>
                                <Image source={{ uri: 'https://juca.eu.org/img/doseexata/default.png' }} style={styles.historyImage} />
                                <View style={styles.historyDetails}>
                                    <Text style={styles.historyName}>{item.nome}</Text>
                                    <Text style={styles.historyDate}>{item.tipo}</Text>
                                </View>
                            </View>
                        </TouchableOpacity>
                    )}
                    ListEmptyComponent={() => (
                        <View style={styles.noResultsContainer}>
                            <Text style={styles.noResultsText}>Medicamento não encontrado.</Text>
                        </View>
                    )}
                />
            </ScrollView>

        </SafeAreaView>
    );
};

const styles = StyleSheet.create({


    noResultsContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 20,
    },
    noResultsText: {
        fontSize: 16,
        color: '#808080',
        fontStyle: 'italic',
    },


    // buscar start
    searchInput: {
        flex: 1,
        fontSize: 16,
        color: '#333',
        paddingVertical: 0,
        paddingHorizontal: 10,
        borderWidth: 0, // Remove qualquer borda extra
        outlineStyle: 'none', // Remove o estilo padrão da Web
        backgroundColor: 'transparent', // Fundo transparente
    },
    searchContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#F5F5F5',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#d3d3d3',
        height: 50,
        paddingHorizontal: 15,
        marginBottom: 20,
        marginHorizontal: 10,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 2,
        width: '95%',
        alignSelf: 'center',
    },
    searchContainerFocused: {
        borderColor: '#004aad', // Destaque no foco
        shadowOpacity: 0.2,
    },
    searchIcon: {
        marginRight: 10,
    },

    // buscar end
    //  itens start


    container: {
        padding: 16,
        backgroundColor: '#F5F5F5',
        flex: 1,
    },


    historyItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 16,
        borderWidth: 1,
        borderColor: '#d3d3d3',
        borderRadius: 8,
        padding: 8,
    },
    historyImage: {
        width: 50,
        height: 50,
        borderRadius: 8,
        marginRight: 16,
    },
    historyDetails: {
        flex: 1,
    },
    historyName: {
        fontSize: 16,
        fontWeight: 'bold',
    },
    historyDate: {
        fontSize: 14,
        color: '#808080',
        marginTop: 4,
    },

    //   itens end 
    safeArea: {
        flex: 1,
        backgroundColor: '#F5F5F5',
        paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight + 10 : 40,
    },
    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 15,
        paddingVertical: height * 0.02, // teste 
    },
    headerTitle: {
        fontSize: width * 0.05,
        fontWeight: 'bold',
        color: '#1F2024',
        textAlign: 'center',
    },
    backButton: {
        position: 'absolute',
        left: 20,
    },
    classificacaoText: {
        fontSize: width * 0.045,
        fontWeight: 'bold',
        color: '#1F2024',
        marginBottom: 20,
        textAlign: 'left',
        paddingLeft: 20,
    },

});

export default RemediosFav;
